import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap } from 'rxjs';

import { OccEndpointsService } from '@spartacus/core';

import { BaseStoreService } from './base-store.service';
import { KlarnaConfig } from '../models';

@Injectable({
  providedIn: 'root'
})
export class KlarnaService {
  klarnaConfiguration: KlarnaConfig;

  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private baseStoreService: BaseStoreService
  ) {}

  getKlarnaConfig(): Observable<KlarnaConfig> {
    const { enableInstallmentPaymentProvider, installmentPaymentProvider } = this.baseStoreService.baseStore;

    if (enableInstallmentPaymentProvider && installmentPaymentProvider === 'KLARNA') {
      if (this.klarnaConfiguration) {
        return of(this.klarnaConfiguration);
      }

      const url = this.occEndpointsService.buildUrl('klarna');

      return this.http.get<KlarnaConfig>(url).pipe(
        tap((config) => {
          this.klarnaConfiguration = config;
        })
      );
    }

    return of({} as KlarnaConfig);
  }
}
